import { Component, OnInit } from '@angular/core';
import {InicioFaces} from '../interfaces/inicioFaces';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';
import {CartasService} from '../services/cartas.service';
import Constants from "../lib/Constants";

@Component({
  selector: 'app-cartas',
  templateUrl: './cartas.component.html',
  styleUrls: ['./cartas.component.css']
})
export class CartasComponent implements OnInit {
consulta: any={};

API_ENDPOINT: string = Constants.BASEURLAPI;

  constructor(private CartasService: CartasService,private httpClient: HttpClient,private formBuilder: FormBuilder, private alerts: AlertsService) { }

  ngOnInit() {
  }

  consultaCedula(){
  var currentUser = JSON.parse(localStorage.getItem('currentUser'));
  this.consulta.login_id = currentUser.login_id;
  console.log('aqui consulta',this.consulta);

  this.CartasService.consultaCedula(this.consulta).subscribe((data: any) => {
        console.log('data servicio ooel',data);

        if (data.status === 200) {
          const url = this.API_ENDPOINT + '/' + data.obj.nombrePdf;

          window.open(url);
        } else {
          alert('DATOS INCORRECTOS PARA GENERAR LA CARTA');
        }
        
      return false
    },
    (error) => {
        alert('Ocurrio un Error');
    });	
	
  }

}
